import { v4 as uuid } from "uuid";

let batchId;
export const getBatchId = shouldGenerateNewOne => {
  if (shouldGenerateNewOne || !batchId) {
    batchId = uuid();
  }
  return batchId;
};
